/**
 * format.tsx — outline glyph icons (never SVG chrome), the EvidenceItem render
 * block (the green dashed panel from the component library), and cognitive-load
 * pips. These are the recurring visual primitives of the instrument aesthetic.
 */
import type { ReactNode } from "react";
import type { LoadLevel } from "../../domain/types.ts";

const GLYPHS: Record<string, string> = {
  spark: "✦",
  stop: "⊘",
  dot: "▸",
  check: "✓",
  doc: "▤",
  edit: "✎",
  lock: "⬡",
  scope: "⊙",
  stack: "▦",
  broadcast: "⊶",
  play: "▷",
  undo: "↺",
  eye: "◉",
  compass: "✧",
  search: "⌕",
  moon: "☾",
  sun: "☀",
  warn: "⚠",
  arrow: "→",
  ne: "≠",
  plus: "+",
};

export function Icon({ name }: { name: string }): JSX.Element {
  return (
    <span className="gly" aria-hidden="true">
      {GLYPHS[name] ?? "▪"}
    </span>
  );
}

export function LoadPips({ level }: { level: LoadLevel }): JSX.Element {
  return (
    <span className={`load ${level}`}>
      <span className="pips">
        <i className="pip" />
        <i className="pip" />
        <i className="pip" />
      </span>
      {level}
    </span>
  );
}

/** Render an EvidenceItem-style block — the monospaced k/v panel with a boundary line. */
export function EvidenceOut({ rows }: { rows: ReadonlyArray<[string, ReactNode]> }): JSX.Element {
  return (
    <div className="evidence-out show">
      {rows.map(([k, v]) => (
        <div key={k} className="ev-row">
          <span className="k">{k}:</span> <span className="v">{v}</span>
        </div>
      ))}
    </div>
  );
}

export function Boundary({ children }: { children: ReactNode }): JSX.Element {
  return <span className="b">{children}</span>;
}
